// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_q4-0";